import React, { useEffect, useState } from "react";
import { BASE_URL } from "../config/api";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";

const EditReminder = () => {
  const { id } = useParams();
  const [title, setTitle] = useState("");
  const [time, setTime] = useState("");
  const [staffId, setStaffId] = useState("");
  const [staffList, setStaffList] = useState([]);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  // Prevent past dates
  const getMinDateTime = () => {
    const now = new Date();
    now.setMinutes(now.getMinutes() - now.getTimezoneOffset());
    return now.toISOString().slice(0, 16);
  };

  // Format datetime for API
  const formatDateTime = (dt) => {
    return dt.replace("T", " ") + ":00";
  };

  // Load staff list
  useEffect(() => {
    fetch("https://pbhrm.com/api/staff")
      .then((res) => res.json())
      .then((data) => {
        if (data.status === 1) {
          setStaffList(data.data);
        }
      })
      .catch((err) => console.log("Staff Load Error:", err));
  }, []);

  // Load reminder data
  useEffect(() => {
    fetch(`${BASE_URL}reminders/${id}`)
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 1) {
          setTitle(data.data.title);
          setStaffId(data.data.staff_id);

          // convert API date → datetime-local
          const formattedTime = new Date(data.data.time)
            .toISOString()
            .slice(0, 16);

          setTime(formattedTime);
        } else {
          setError("Unable to load reminder");
        }
      })
      .catch((err) => console.error("Reminder Load Error:", err));
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!title || !time || !staffId) {
      setError("Title, Time & Staff are required");
      return;
    }

    const payload = {
      title,
      time: formatDateTime(time),
      staff_id: parseInt(staffId),
    };

    try {
      const res = await fetch(`${BASE_URL}reminders/${id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const result = await res.json();

      if (result.status === 1) {
        Swal.fire({
          icon: "success",
          title: "Reminder updated successfully",
        });
        navigate("/RemindersList");
      } else {
        setError(result.message);
      }
    } catch (error) {
      setError("Update failed");
      console.log("Update Error:", error);
    }
  };

  return (
    <div id="main">
      <header className="mb-3">
        <a href="#" className="burger-btn d-block d-xl-none">
          <i className="bi bi-justify fs-3"></i>
        </a>
      </header>

      <div className="page-heading">
        <div className="page-title">
          <div className="row">
            <div className="col-12 col-md-6 order-md-1 order-last">
              <h3>Edit Reminder</h3>
            </div>
          </div>
        </div>
      </div>

      <section className="section">
        <div className="row" id="basic-table">
          <div className="col-12 col-md-12">
            <div className="card">
              <div className="card-header">
                <h4>Edit Reminder</h4>
              </div>
              <div className="card-body">
                {error && <div className="alert alert-danger">{error}</div>}

                <form onSubmit={handleSubmit}>
                  <div className="mb-3">
                    <label className="form-label">Title</label>
                    <input
                      type="text"
                      className="form-control"
                      value={title}
                      onChange={(e) => setTitle(e.target.value)}
                    />
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Time</label>
                    <input
                      type="datetime-local"
                      className="form-control"
                      value={time}
                      min={getMinDateTime()}
                      onChange={(e) => setTime(e.target.value)}
                    />
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Select Staff</label>
                    <select
                      className="form-control"
                      value={staffId}
                      onChange={(e) => setStaffId(e.target.value)}
                    >
                      <option value="">-- Select Staff --</option>

                      {staffList.map((s) => (
                        <option key={s.id} value={s.id}>
                          {s.name} ({s.email})
                        </option>
                      ))}
                    </select>
                  </div>

                  <button type="submit" className="btn btn-primary">
                    Update Reminder
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default EditReminder;
